import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { ICON_TYPE, IconModule } from '@spartacus/storefront';

@Component({
  selector: 'sanofi-order-capping-cart-banner',
  standalone: true,
  imports: [
    I18nModule,
    IconModule
  ],
  templateUrl: './order-capping-cart-banner.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderCappingCartBannerComponent {
  protected readonly iconTypes = ICON_TYPE;
  visible = model<boolean>(false);
}
